import { css, keyframes } from "@emotion/react";


export const animatedCss = css`
width: 20px;
height: 20px;
line-height: 20px;
text-align: center;
overflow: hidden;
display: flex;
align-items: center;
justify-content: center;
`;


const progress = keyframes`
0 {
  transform: rotate(0deg);
}
100% {
  transform: rotate(360deg);
}
`;


export const loaderCss = css`
width: 1em;
height: 1em;
animation: ${progress} 1s linear infinite;;
`;
